import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faBan, faInfoCircle, faPlusSquare, faMinusSquare } from '@fortawesome/free-solid-svg-icons';
import { AppComponent } from './app.component';
import { AgGridModule } from '@ag-grid-community/angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HomeComponent } from './home/home.component';
import { HealthcareLiabilityComponent } from './healthcare-liability/healthcare-liability.component';

import { NavbarComponent } from './navbar/navbar.component';
import { HttpClientModule } from '@angular/common/http';
import { ProfileComponent } from './profile/profile.component';
import { UWSummaryComponent } from './uw/uwsummary/uwsummary.component';
import { UWDetailComponent } from './uw/uwdetail/uwdetail.component';
import { AcordSummaryComponent } from './uw/acord-summary/acord-summary.component';
import { AcordDetailComponent } from './uw/acord-detail/acord-detail.component';
import { RouterLinkCellRendererComponent } from './router-link-cell-renderer/router-link-cell-renderer.component';
import { RbacAllowDirective } from './rbac-allow.directive';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CustomTooltip } from './uw/acord-detail/custom-tooltip.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from './auth/interceptor.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgBusyModule } from 'ng-busy';
import { WorkflowSummaryComponent } from './workflow/workflow-summary/workflow-summary.component';
import { WorkflowDetailComponent } from './workflow/workflow-detail/workflow-detail.component';
import { GlEiTopClaimsComponent} from './visualizations/gl-ei-top-claims/gl-ei-top-claims.component';
import { GlEiSameEffortComponent} from './visualizations/gl-ei-same-effort/gl-ei-same-effort.component';
import { DownloadFileCellRenderer} from "./healthcare-liability/download-file-cell-renderer";

// import { WorkflowComponent } from './workflow/workflow/workflow.component';
// import '@ag-grid-community/client-side-row-model';
// import { WorkflowLogComponent } from './workflow/workflow/workflow-log.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HealthcareLiabilityComponent,
    NavbarComponent,
    ProfileComponent,
    UWSummaryComponent,
    AcordDetailComponent,
    AcordSummaryComponent,
    UWDetailComponent,
    AcordSummaryComponent,
    AcordDetailComponent,
    RouterLinkCellRendererComponent,
    RbacAllowDirective,
    BreadcrumbComponent,
    CustomTooltip,
    WorkflowSummaryComponent,
    WorkflowDetailComponent,
    GlEiTopClaimsComponent,
    GlEiSameEffortComponent,
    DownloadFileCellRenderer
    // WorkflowComponent,
    // WorkflowLogComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    FontAwesomeModule,
    // AgGridModule.withComponents([RouterLinkCellRendererComponent, CustomTooltip, WorkflowLogComponent]),
    AgGridModule.withComponents([RouterLinkCellRendererComponent, CustomTooltip, DownloadFileCellRenderer]),
    AppRoutingModule,
    BrowserAnimationsModule,
    NgBusyModule,
    NgbModule,
  ],
  providers: [{
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private library: FaIconLibrary) {
    library.addIcons(faInfoCircle, faBan, faPlusSquare, faMinusSquare);
  }
}
